import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectLandingPageDetails } from '../redux/otherDetailsSlice'
import { PropagateLoader } from 'react-spinners'
import CompaniesSection from '../pages/NewPostPaymentFeature/CompaniesSection'
import ScreenWrapper from './ScreenWrapper'
import { Mixpanel } from '../config/Mixpanel'
import constants from '../utilities/constants'

const NewSuspenseLoader = ({ trackEvent }) => {

    const landingPage = useSelector(selectLandingPageDetails)

    const skillName = landingPage?.skill_name

    useEffect(() => {
        if(trackEvent){
            Mixpanel.track(constants.Mixpanel.NEW_SCANNING_LOADER_SCREEN_WAS_LOADED)
        }
    }, [trackEvent])

    return (
        <ScreenWrapper useFullWidth={false}>
            <div className='flex-1 flex flex-col text-white text-center'>
                <div className='flex-1 flex flex-col justify-center'>
                    <div className='w-fit p-6 mx-auto relative'>
                        <div className='relative'>
                            <img src="https://assets.learntube.ai/files/Global/cert.png?updatedAt=1743241648024" loading='eager' width={180} height={127} className='mx-auto' alt="" />
                            <div className='absolute animation-layer-2' />
                        </div>
                        <div className='absolute border-l border-t border-bg-13 w-10 h-10 left-0 top-0' />
                        <div className='absolute border-l border-b border-bg-13 w-10 h-10 left-0 bottom-0' />
                        <div className='absolute border-r border-t border-bg-13 w-10 h-10 right-0 top-0' />
                        <div className='absolute border-r border-b border-bg-13 w-10 h-10 right-0 bottom-0' />
                    </div>
                    <h2 className='mt-6 text-xl'>Great job! You are one step closer to your verified <span className='font-semibold text-span_color'>{skillName}</span> certificate...</h2>
                    <div className='mt-8'>
                        <PropagateLoader color='#7FC241' size={20}/>
                    </div>
                </div>
                <div className='w-full text-center'>
                    <p className='text-sm text-white/50 mb-1'>Certificate Recognized By <span className='font-medium text-white'>1,100+ Hiring Companies</span></p>
                    <CompaniesSection />
                </div>
            </div>
        </ScreenWrapper>
    )
}

export default NewSuspenseLoader